<template>
    <masonry
        :cols="{default: 3, 991: 2, 768: 1}"
        :gutter="15">

        <ul
        v-for="(coleccion, i) in colecciones.filter(f => f.nombre != 'todos')"
        :key="i"
        class="list">
        <li @click="handleColectionType(coleccion)">
            {{coleccion.nombre}}
        </li>
        <li 
            v-for="(esquema, e) in getEsquemasByColeccion(coleccion.id)"
            :key="e"
            @click="handleDocumentType(esquema)">
            <i class="el-icon-arrow-right"></i>
            {{esquema.descripcion.replace(/_|#|-|@|<>/g, " ")}}
        </li>
        </ul>
    </masonry>
</template>

<script>
export default {
    name: 'FilterCollectionsSchemes',
    props: {
        colecciones: {
            type: Array,
            default: []
        },
        esquemas: {
            type: Array,
            default: []
        }
    },
    methods: {
        getEsquemasByColeccion(id) {
            return this.esquemas.filter(f => f.coleccion_esquema__id == id)
        },
        // Cambiar coleccion
        handleColectionType(collection) {
            this.$emit('handleColectionType', {
                coleccion: collection.id
            })
        },
        handleDocumentType(esquema) {

            this.$emit('handleDocumentType', {
                esquema: esquema.id,
                coleccion: esquema.coleccion_esquema__id
            })

        }     
    }
}
</script>

<style lang="scss">

</style>